import React, { useState, useRef } from "react";
import axios from "axios";
import JoditEditor from "jodit-react";
import slugify from "slugify";

export default function Addnews(props) {
  const [title, setTitle] = useState("");
  const [slug, setSlug] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [author, setAuthor] = useState("");
  const editor = useRef(null);
  const [image, setImage] = useState("");
  const [date, setDate] = useState("");
  const [cloudImage, setCloudImage] = useState("");
  const [imageUrl, setimageUrl] = useState("");
  const [keywords, setKeywords] = useState("");

  const config = {
    readonly: false, // all options from https://xdsoft.net/jodit/doc/
  };

  const AddImage = () => {
    const formData = new FormData();
    formData.append("file", cloudImage);
    formData.append("upload_preset", "tamizhtechie");
    formData.append("cloud_name", "tamizhtechie");
    fetch("https://api.cloudinary.com/v1_1/tamizhtechie/image/upload", {
      method: "post",
      body: formData,
    })
      .then((res) => res.json())
      .then((formData) => {
        setimageUrl(formData.url);
        alert("image Uploaded");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const AddData = () => {
    const formData = new FormData();
    // formData.append("image", image);
    formData.append("title", title);
    formData.append(
      "slug",
      slugify(slug, {
        lower: true,
      })
    );
    formData.append("category", category);
    formData.append("description", description);
    formData.append("author", author);
    formData.append("date", date);
    formData.append("imageUrl", imageUrl);
    formData.append("keywords", keywords);

    try {
      let password = prompt("Enter password");
      if (password === "tamizhtechie") {
        const response = axios({
          method: "post",
          url: "https://tamizhtechie-test.herokuapp.com/blog/",
          data: formData,
          headers: { "Content-Type": "multipart/form-data" },
        });
        alert("Data inserted successfully");
        setAuthor("");
        setTitle("");
        setSlug("");
        setDescription("");
      } else {
        alert("You are wrong");
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container addnews">
      {/* <form onSubmit={() => AddData()}> */}
      <div className="row">
        <div className="col-md-6">
          <input
            type="text"
            className="form-control"
            placeholder="Title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <input
            type="text"
            className="form-control"
            placeholder="Slug"
            value={slugify(slug, {
              lower: true,
            })}
            onChange={(e) => setSlug(e.target.value)}
          />
        </div>
        <div className="col-md-6">
          <input
            type="date"
            className="form-control"
            placeholder="Date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
        </div>

        <div className="col-md-6">
          <select
            className="form-control"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            name="category"
          >
            <option value="">---- Select Category -----</option>
            <option value="techietalks">Techietalks</option>
            <option value="trending">Trending</option>
            <option value="developerzone">Developer Zone</option>
            <option value="gadget">Gadget</option>
            <option value="udemycoupons">Udemy Coupons</option>
          </select>

          {/* <input
            type="text"
            className="form-control"
            placeholder="Category"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          /> */}
        </div>
        <div className="col-md-6">
          <select
            className="form-control"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
            name="author"
          >
            <option value="">---- Select Author -----</option>
            <option value="Balaji">Balaji</option>
            <option value="Rakshana">Rakshana</option>
          </select>

          {/* <input
            type="text"
            className="form-control"
            placeholder="Author"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          /> */}
        </div>

        <div className="col-md-6">
          <input
            type="text"
            className="form-control"
            placeholder="Keywords"
            value={keywords}
            onChange={(e) => setKeywords(e.target.value)}
          />{" "}
        </div>
      </div>
      <div className="row mt-4">
        {/* <div className="col-md-6">
          <input
            type="file"
            name="file"
            onChange={(e) => {
              const file = e.target.files[0];
              setImage(file);
            }}
          />
        </div> */}
        <div className="col-md-6">
          <input
            type="file"
            onChange={(e) => setCloudImage(e.target.files[0])}
          />
        </div>
      </div>

      <div className="row mt-5">
        <div className="col-md-12">
          <JoditEditor
            name="content"
            ref={editor}
            value={description}
            config={config}
            tabIndex={1} // tabIndex of textarea
            onBlur={(newContent) => setDescription(newContent)} // preferred to use only this option to update the content for performance reasons
            onChange={(newContent) => {}}
          />
        </div>
      </div>

      <button onClick={() => AddImage()} className=" btn btn-primary mt-3">
        Add image
      </button>

      <button onClick={() => AddData()} className="ml-5 btn btn-primary mt-3">
        Add Data
      </button>
    </div>
  );
}
